/**
 * Ids of the attendance_target_set_type lookup table. Performance band sets are typed so that
 * Attendance bands and Chronic Absence bands can be configured and read independently.
 */
export const ATTENDANCE_TARGET_SET_TYPE = {
    ATTENDANCE: 1,
    CHRONIC_ABSENCE: 2
}
